// removed by extract-text-webpack-plugin
module.exports = {"root":"_1IOu3v4_dDvmxxR2XkE5E3","filter-wrapper":"Fb1NneL6W0NOLAmssKEuz","other-filters":"f4TmHfxjLic0Pbxe01FiZ","form-field":"_1pEQdruLsbpQWNQh7JEmxv","active":"_8OyDfXCOQEtLNXgS_Vtzq"};


//////////////////
// WEBPACK FOOTER
// ./src/components/project/show/submissions/filters/filters.scss
// module id = 1673
// module chunks = 0